import styled, { css } from 'styled-components';
import { Spacing16, Spacing24 } from 'autogen/design-tokens/tokens';
import type { ExtendedPlaceholderContentModel } from 'autogen/swagger/all';
import DynamicItemCarousel from 'components/generic/ScrollSnapSlider/components/DynamicItemCarousel';
import { Headline } from 'components/generic/typography';
import { breakpoint, sizes } from 'variables';
import ArticleContentItem from './ArticleContentItem';

interface IArticleContentRowProps {
    model: ExtendedPlaceholderContentModel;
}

const Wrapper = styled.div`
    position: relative;
`;

const Header = styled(Headline)`
    margin-bottom: ${Spacing16};

    ${breakpoint.up(sizes.md)} {
        padding: 0;
        margin-bottom: ${Spacing24};
    }
`;

const StyledDynamicItemCarousel = styled(DynamicItemCarousel)`
    width: 100%;
` as typeof DynamicItemCarousel;

const scrollContainerStyling = css`
    && {
        padding: 0 ${Spacing24};
        scroll-padding-inline-end: ${Spacing24};
        scroll-padding-inline-start: ${Spacing24};

        ${breakpoint.up(sizes.xl)} {
            scroll-padding-inline-end: 0;
            scroll-padding-inline-start: 0;
            padding: 0;
        }
    }
`;

const CarouselOverflowContainer = styled.div`
    position: relative;
    margin: 0 -${Spacing16};

    ${breakpoint.up(sizes.xl)} {
        margin: 0;
    }
`;

export default function ArticleContentRow(props: IArticleContentRowProps): JSX.Element {
    const {
        model: { items, heading }
    } = props;

    return (
        <Wrapper>
            {heading && <Header size="L">{heading}</Header>}
            <CarouselOverflowContainer>
                <StyledDynamicItemCarousel
                    gapSize={Spacing24}
                    scrollContainerCss={scrollContainerStyling}
                    items={items}
                    itemRenderer={(item, index) => (
                        <ArticleContentItem item={item} key={item.heading || index} data-slide-index={index} />
                    )}
                />
            </CarouselOverflowContainer>
        </Wrapper>
    );
}
